module.exports = __webpack_public_path__ + "static/media/search-active.35665159.svg";